// extracted by mini-css-extract-plugin
export default {"starIcon":"IconGroup_starIcon__SmjpD","forkIcon":"IconGroup_forkIcon__Ygxh7","languageIcon":"IconGroup_languageIcon__ilEMU"};